/**
 * Bank utilities for ID to display name conversion
 */

/**
 * Convert bank ID to user-friendly display name.
 *
 * @param bankId Bank ID like 'banco-bci'
 * @returns Display name like 'Banco de Crédito e Inversiones'
 */
export function getBankDisplayName(bankId: string): string {
  if (!bankId) {
    return bankId;
  }

  // Bank ID to display name mapping
  const bankDisplayNames: Record<string, string> = {
    'banco-abc': 'Banco ABC',
    'banco-bice': 'Banco BICE',
    'banco-consorcio': 'Banco Consorcio',
    'banco-de-chile': 'Banco de Chile',
    'banco-bci': 'Banco de Crédito e Inversiones',
    'banco-estado': 'Banco del Estado de Chile',
    'banco-falabella': 'Banco Falabella',
    'banco-internacional': 'Banco Internacional',
    'banco-itau': 'Banco Itaú Chile',
    'banco-ripley': 'Banco Ripley',
    'banco-santander': 'Banco Santander Chile',
    'banco-security': 'Banco Security',
    'banco-hsbc': 'HSBC Bank Chile',
    'banco-scotiabank': 'Scotiabank Chile',
    'banco-tanner': 'Tanner Banco Digital',
    'cb-btg-pactual': 'BTG Pactual Corredores de Bolsa',
    'cb-credicorp': 'Credicorp Capital Corredores de Bolsa',
    'cb-euroamerica': 'EuroAmérica Corredores de Bolsa',
    'cb-nevasa': 'Nevasa Corredores de Bolsa',
  };

  return bankDisplayNames[bankId.toLowerCase()] || bankId;
}
